import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Divider,
} from "@mui/material";
import { ReactComponent as ArrowRight } from "../../../assets/jobIcons/arrow-right-white.svg";
import ArrowsUpDown from "../../icons/ArrowsUpDown";
import Circle, { CircleColor } from "../../icons/Circle";
import ByteChip from "../../icons/ByteChip";

export interface PriceCardProps {
  title: string;
  subtitle?: string;
  tokenValue: number;
  dollarValue: number;
  unitPrice: number;
  onSelect?: () => void;
  color: CircleColor;
  disabled?: boolean;
  isSubscription?: boolean;
  dividerVariant?: "arrows" | "line";
}

const PriceCard: React.FC<PriceCardProps> = ({
  // title,
  // subtitle,
  tokenValue,
  dollarValue,
  unitPrice,
  onSelect,
  // color,
  disabled,
  // isSubscription,
  dividerVariant = "arrows",
}) => {
  return (
    <Card sx={{ width: "250px", boxShadow: "0 0 10 0 rgba(0, 0, 0, 0.25)" }}>
      <CardContent>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box display="flex" flexDirection="row" alignItems="center">
            <div>
              <ByteChip color="secondary" colorVariant="dark" />
            </div>
            <Typography variant="h1" color="secondary.dark">
              {tokenValue}
            </Typography>
          </Box>
          <Divider sx={{ width: "160px" }} />
          <Box my={1}>
            {dividerVariant === "arrows" ? (
              <ArrowsUpDown color="secondary" colorVariant="dark" />
            ) : (
              <Divider sx={{ width: "160px" }} />
            )}
          </Box>
          <Typography variant="h1" color="secondary.dark">
            $ {dollarValue / 100}
            {/* $ {Number(Number(dollarValue).toFixed(8)) / 100} */}
          </Typography>
          <Typography variant="body2" color="grey.200">
            ${unitPrice.toFixed(8)}/ByteChip
          </Typography>
          {onSelect && (
            <Box mt={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={onSelect}
                disabled={disabled}
              >
                Select
                <ArrowRight style={{ marginLeft: "10px" }} color="white" />
              </Button>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default PriceCard;
